
import { makeStyles } from '@material-ui/core';
import React from 'react'
import { CancelCrudButtons } from '../ui/CancelCrudButtons';
import { Modal } from '../ui/Modal';

const useStyles = makeStyles((theme: any) => ({
    errorContent: {
        color: "#b40000",
        fontWeight: 'bold'
    },
}));

interface Props {
    confirmWeekChangeModalHidden: boolean;
    setConfirmWeekChangeModalHidden: React.Dispatch<React.SetStateAction<boolean>>;
    confirmFunction: () => void
}

export const ConfirmWeekChangeModal: React.FC<Props> = ({confirmWeekChangeModalHidden,setConfirmWeekChangeModalHidden,confirmFunction}) => {
    const classes = useStyles()

    return (
        <Modal title='Alert' hidden={confirmWeekChangeModalHidden} setHidden={setConfirmWeekChangeModalHidden}>
            <div>
                <div className={classes.errorContent}>
                    Your current selection will be lost. It is only possible to book a week at a time. 
                </div>
                <CancelCrudButtons 
                    hidden={confirmWeekChangeModalHidden} 
                    setHidden={setConfirmWeekChangeModalHidden} 
                    isDelete={false} 
                    postEntity={confirmFunction}
                    postButtonText={"Yes I'm sure"}/>
            </div>
        </Modal>
    );
}